import moment from "moment";
import React, { useEffect, useState } from "react";
import { PieChart } from "react-minimal-pie-chart";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import climate from "../Assets/Icon/climate.webp";
import {
  DirectorDashboardCount,
  DirectorDashboardLeaveList,
  EmployeeDashboardCount
} from "../Repository/Api";
import { GetInitials } from "../Store/constants";
import { errorMsg } from "./Toastify";

const Dashboard = () => {
  const { first_name, desingation, user_type_value, department, officer_type, access_token,id } = useSelector((state) => state?.auth?.auth);
  const token = access_token
  const navigate = useNavigate();
  const [count, setCount] = useState({});
  const [leavePerson, setLeavePerson] = useState({});
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    getDashboard();
    getLeavePerson();
  },[]);

  const getDashboard = async () => {
    setLoading(true);

    const dashboardFunctions = {
      employee: EmployeeDashboardCount,
      director: DirectorDashboardCount,
    };

    const userType = user_type_value;
    const dashboardFunction = dashboardFunctions[userType];

    if (!dashboardFunction) {
      setLoading(false);
      return;
    }

    try {
      const response = await dashboardFunction(token);

      setTimeout(() => {
        if (response && response.statusCode === 200) {
          setCount(response?.data);
        } else {
          errorMsg(response.message);
        }
        setLoading(false);
      }, 500);
    } catch (error) {
      errorMsg("An error occurred while fetching the dashboard data.");
      setLoading(false);
    }
  };
  const getLeavePerson = async () => {
    if (user_type_value === "director") {
      const response = await DirectorDashboardLeaveList(token);
      if (response && response.statusCode === 200) {
        setLeavePerson(response?.data?.leave_details);

      } else {
        errorMsg(response.message);
      }
    }
  };

  const datacasual = [
    { title: "One", value: count?.casual_leave_balance, color: "#A3AED0" },
    {
      title: "Two",
      value: count?.casual_leave_current_year_taken,
      color: "#33A3F4",
    },
  ];
  const dataearned = [
    {
      title: "One",
      value: count?.earned_leave_balance,
      color: "#A3AED0",
    },
    {
      title: "Two",
      value: count?.earned_leave_current_year_taken,
      color: "#33A3F4",
    },
  ];
  const datamedical = [
    { title: "One", value: count?.medical_leave_balance, color: "#A3AED0" },
    {
      title: "Two",
      value: count?.medical_leave_current_year_taken,
      color: "#33A3F4",
    },
  ];
  const dataextraleave = [
    {
      title: "One",
      value: "",
      color: "#A3AED0",
    },
    {
      title: "Two",
      value: count?.extra_ordinary_leave_current_year_taken,
      color: "#33A3F4",
    },
  ];
  const dataresholiday = [
    {
      title: "One",
      value: count?.restricted_holiday_balance,
      color: "#A3AED0",
    },
    {
      title: "Two",
      value: count?.restricted_holiday_current_year_taken,
      color: "#33A3F4",
    },
  ];
  const datacamp = [
    { title: "One", value: count?.comp_off_balance, color: "#A3AED0" },
    {
      title: "Two",
      value: count?.comp_off_current_year_taken,
      color: "#33A3F4",
    },
  ];
  const dataspecial = [
    {
      title: "One",
      value: count?.special_casual_leave_balance,
      color: "#A3AED0",
    },
    {
      title: "Two",
      value: count?.special_casual_leave_current_year_taken,
      color: "#33A3F4",
    },
  ];

  return (
    <>
      <div className="">
        <section className="top-content-container">
          {user_type_value === "employee" ? (
            <div className="row align-items-center my-4">
              <div className="col-lg-6">
                <h6 className="headertext">
                  {first_name} - {desingation}
                </h6>
                <h6 className="subheadertext">{department}</h6>
              </div>
<div className="col-lg-6">
  <div className="headeralign"> 
    <button
      className="requestbtn"
      onClick={() => {
        window.open(
          `https://nitttrc.edu.in/visitor/APAR/consolidated.php?employee_id=${id}`, 
          "_blank", 
          "noopener,noreferrer"
        );
      }}
    >
      Verify Performance Report
    </button>
  </div>
</div>






              <div className="col-lg-6">
                <div className="headeralign">
                  <button
                    className="requestbtn"
                    onClick={() => {
                      navigate("/app/Staff/Staffleaveapply");
                    }}
                  >
                    Request For Leave
                  </button>
                </div>
              </div>
            </div>
          ) : (
            ""
          )}
          {user_type_value === "hod"
            ? navigate("/app/Hod/HodLeaverequest")
            : ""}
          {/* {user_type_value === "admin"
            ? navigate("/app/admin/AdminLeaverequest")
            
            : ""} */}

{user_type_value === "admin" && (
  <div className="row my-4">
    <div className="col-lg-6 p-0">
      <h6 className="headertext">{first_name}</h6>
    </div>
    <div className="col-lg-6 p-0">
      <div className="headeralign">
        <button
          className="requestbtn"
          onClick={() => navigate("/app/admin/AdminLeaverequest")}
        >
          View to Request
        </button>
        <button
          className="requestbtn"
          onClick={() =>
            (window.location.href =
              //"http://14.139.191.171:8081/Leave_Mail/AO/Leave_Approval.php")
              "https://nitttrc.edu.in/LeaveApproval/AO/Leave_Approval.php")
          }
        >
          Pending Approval
        </button>
      </div>
    </div>
  </div>
)}

          {user_type_value === "director" ? (
            <div className="row my-4">
              <div className="col-lg-6 p-0">
                <h6 className="headertext">{first_name}</h6>
              </div>
              <div className="col-lg-6 p-0">
                <div className="headeralign">
                  <button
                    className="requestbtn"
                    onClick={() => {
                      navigate("/app/Director/DirectorLeaverequest");
                    }}
                  >
                    View to Request
                  </button>
                  <button
                    className="requestbtn"
                    onClick={() => {
                      window.location.href = "https://nitttrc.edu.in/LeaveApproval/Director/Leave_approval.php";
                    }}
                  >
                    Pending Approval
                  </button>
                </div>
              </div>
            </div>
          ) : (
            ""
          )}
          
          {user_type_value === "system_admin"
            ? navigate("/app/Systemadmin/Masterdata")
            : ""}
          {user_type_value === "indent"
            ? navigate("/app/Indent/IndentApplication")
            : ""}
          {user_type_value === "store_incharge"
            ? navigate("/app/Stores/StoreMaster")
            : ""}
        </section>
        <section>
          <div className="row">
            <div className="">
              {!loading ? (
                <>
                  {user_type_value === "employee" ? (
                    <>
                      <div className="row ">
                        <div className="col-lg-3 d-flex">
                          <div className="timebox">
                            <div className="row">
                              <div className="col-lg-10 mx-auto ms-auto">
                                <div className="row my-4">
                                  <div className="col-lg-4 my-auto">
                                    <div className="centertext">
                                      <img
                                        className="climateicon"
                                        src={climate}
                                        alt="climate"
                                      />
                                    </div>
                                  </div>
                                  <div className="col-lg-8 p-0 my-auto">
                                    <h6 className="time">
                                      {moment(new Date()).format("LTS")}
                                    </h6>
                                    <h6 className="timetext">
                                      Realtime Insight
                                    </h6>
                                  </div>
                                </div>
                                <div className="my-5">
                                  <h6 className="todaytext">Today : </h6>
                                  <h6 className="todaytext">
                                    {moment(new Date()).format("Do MMMM yyyy")}
                                  </h6>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="col-lg-9">
                          <div className="row">
                            <div className="col-lg-4 d-flex">
                              <div className="timebox">
                                <div className="row">
                                  <div className="col-lg-4">
                                    <PieChart
                                      data={datacasual}
                                      lineWidth={30}
                                      labelPosition={0}
                                      startAngle={130}
                                    />
                                  </div>
                                  <div className="col-lg-8">
                                    <div className="mt-3">
                                      <h6 className="leavetitle">
                                        Casual Leave
                                      </h6>
                                      <h6 className="leavesubtitle">
                                        <span className="dot1"></span>
                                        &nbsp;Remaining - &nbsp;
                                        {count?.casual_leave_balance}
                                      </h6>
                                      <h6 className="leavesubtitle">
                                        <span className="dot2"></span>{" "}
                                        &nbsp;Used -{" "}
                                        {count?.casual_leave_current_year_taken}
                                      </h6>
                                      <h6 className="leavesubtitle">
                                        <span className="dot3"></span>{" "}
                                        &nbsp;Total -&nbsp;
                                        {count?.casual_leave_total_days}
                                      </h6>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="col-lg-4 d-flex">
                              <div className="timebox">
                                <div className="row">
                                  <div className="col-lg-4">
                                    <PieChart
                                      data={dataearned}
                                      lineWidth={30}
                                      labelPosition={0}
                                      startAngle={90}
                                    />
                                  </div>
                                  <div className="col-lg-8">
                                    <div className="mt-3">
                                      <h6 className="leavetitle">
                                        Earned Leave
                                      </h6>
                                      <h6 className="leavesubtitle">
                                        <span className="dot1"></span>
                                        &nbsp;Remaining -&nbsp;
                                        {count?.earned_leave_balance}
                                      </h6>
                                      <h6 className="leavesubtitle">
                                        <span className="dot2"></span>{" "}
                                        &nbsp;Used -&nbsp;
                                        {count?.earned_leave_current_year_taken}
                                      </h6>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="col-lg-4 d-flex">
                              <div className="timebox">
                                <div className="row">
                                  <div className="col-lg-4">
                                    <PieChart
                                      data={datamedical}
                                      lineWidth={30}
                                      labelPosition={0}
                                      startAngle={90}
                                    />
                                  </div>
                                  <div className="col-lg-8">
                                    <div className="mt-3">
                                      <h6 className="leavetitle">
                                        Half Pay Leave(HPL)
                                      </h6>
                                      <h6 className="leavesubtitle">
                                        <span className="dot1"></span>
                                        &nbsp;Remaining -{" "}
                                        {count?.medical_leave_balance}
                                      </h6>
                                      <h6 className="leavesubtitle">
                                        <span className="dot2"></span>{" "}
                                        &nbsp;Used -{" "}
                                        {
                                          count?.medical_leave_current_year_taken
                                        }
                                      </h6>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="row mt-3">
                            <div className="col-lg-4 d-flex">
                              <div className="timebox">
                                <div className="row">
                                  <div className="col-lg-4">
                                    <PieChart
                                      data={dataresholiday}
                                      lineWidth={30}
                                      labelPosition={0}
                                      startAngle={90}
                                    />
                                  </div>
                                  <div className="col-lg-8">
                                    <div className="mt-3">
                                      <h6 className="leavetitle">
                                        Restricted Holidays
                                      </h6>
                                      <h6 className="leavesubtitle">
                                        <span className="dot1"></span>{" "}
                                        &nbsp;Remaining -{" "}
                                        {count?.restricted_holiday_balance}
                                      </h6>
                                      <h6 className="leavesubtitle">
                                        <span className="dot2"></span>{" "}
                                        &nbsp;Used -{" "}
                                        {
                                          count?.restricted_holiday_current_year_taken
                                        }
                                      </h6>
                                      <h6 className="leavesubtitle">
                                        <span className="dot3"></span>{" "}
                                        &nbsp;Total -{" "}
                                        {count?.restricted_holiday_total_days}
                                      </h6>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            {officer_type === 'group_a_officer' ? '' : officer_type === "supporting_staff" ? (
                              <div className="col-lg-4 d-flex">
                                <div className="timebox">
                                  <div className="row">
                                    <div className="col-lg-4">
                                      <PieChart
                                        data={datacamp}
                                        lineWidth={30}
                                        labelPosition={0}
                                        startAngle={90}
                                      />
                                    </div>
                                    <div className="col-lg-8">
                                      <div className="mt-3">
                                        <h6 className="leavetitle">Comp Off</h6>
                                        <h6 className="leavesubtitle">
                                          <span className="dot1"></span>
                                          &nbsp;Remaining -{" "}
                                          {count?.comp_off_balance}
                                        </h6>
                                        <h6 className="leavesubtitle">
                                          <span className="dot2"></span>{" "}
                                          &nbsp;Used -{" "}
                                          {count?.comp_off_current_year_taken}
                                        </h6>
                                        <h6 className="leavesubtitle">
                                          <span className="dot3"></span>{" "}
                                          &nbsp;Total -{" "}
                                          {count?.comp_off_total_days}
                                        </h6>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            ) : (
                              <div className="col-lg-4 d-flex">
                                <div className="timebox">
                                  <div className="row">
                                    <div className="col-lg-4">
                                      <PieChart
                                        data={dataspecial}
                                        lineWidth={30}
                                        labelPosition={0}
                                        startAngle={90}
                                      />
                                    </div>
                                    <div className="col-lg-8">
                                      <div className="mt-3">
                                        <h6 className="leavetitle">
                                          Special Casual Leave
                                        </h6>
                                        <h6 className="leavesubtitle">
                                          <span className="dot1"></span>
                                          &nbsp;Remaining -{" "}
                                          {count?.special_casual_leave_balance}
                                        </h6>
                                        <h6 className="leavesubtitle">
                                          <span className="dot2"></span>{" "}
                                          &nbsp;Used -{" "}
                                          {
                                            count?.special_casual_leave_current_year_taken
                                          }
                                        </h6>
                                        <h6 className="leavesubtitle">
                                          <span className="dot3"></span>{" "}
                                          &nbsp;Total -{" "}
                                          {
                                            count?.special_casual_leave_total_days
                                          }
                                        </h6>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            )}
                            <div className="col-lg-4 d-flex">
                              <div className="timebox">
                                <div className="row">
                                  <div className="col-lg-4">
                                    <PieChart
                                      data={dataextraleave}
                                      lineWidth={30}
                                      labelPosition={0}
                                      startAngle={90}
                                    />
                                  </div>
                                  <div className="col-lg-8">
                                    <div className="mt-3">
                                      <h6 className="leavetitle">
                                        Extra Ordinary Leave
                                      </h6>
                                      <h6 className="leavesubtitle">
                                        <span className="dot2"></span>{" "}
                                        &nbsp;Used -&nbsp;
                                        {
                                          count?.extra_ordinary_leave_current_year_taken
                                        }
                                      </h6>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </>
                  ) : (
                    ""
                  )}
                  {user_type_value === "director" ? (
                    <>
                      <div className="row">
                        <div className="col-lg-8">
                          <div className="row">
                            <div className="col-lg-6 mb-3">
                              <div className="countbox">
                                <div className="row">
                                  <div className="col-lg-9">
                                    <div className="counttitle">
                                      {count?.total_enployees}
                                    </div>
                                    <h6 className="countsubtitle">
                                      Total Employee Count
                                    </h6>
                                  </div>
                                  <div className="col-lg-3 my-auto">
                                    <div className="counticonbg">
                                      <span className="material-symbols-outlined counticon">
                                        groups
                                      </span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="col-lg-6 mb-3">
                              <div className="countbox">
                                <div className="row">
                                  <div className="col-lg-9">
                                    <div className="counttitle">
                                      {count?.total_hod}
                                    </div>
                                    <h6 className="countsubtitle">
                                      Total Hod Count
                                    </h6>
                                  </div>
                                  <div className="col-lg-3 my-auto">
                                    <div className="counticonbg">
                                      <span className="material-symbols-outlined counticon">
                                        diversity_3
                                      </span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="col-lg-6 mb-3">
                              <div className="countbox">
                                <div className="row">
                                  <div className="col-lg-9">
                                    <div className="counttitle">
                                      {count?.total_leave_pending_status}
                                    </div>
                                    <h6 className="countsubtitle">
                                      Total Pending Leave
                                    </h6>
                                  </div>
                                  <div className="col-lg-3 my-auto">
                                    <div className="counticonbg">
                                      <span className="material-symbols-outlined counticon">
                                        pending_actions
                                      </span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="col-lg-6 mb-3">
                              <div className="countbox">
                                <div className="row">
                                  <div className="col-lg-9">
                                    <div className="counttitle">
                                      {count?.total_leave_approved_status}
                                    </div>
                                    <h6 className="countsubtitle">
                                      Total Approved Leave
                                    </h6>
                                  </div>
                                  <div className="col-lg-3 my-auto">
                                    <div className="counticonbg">
                                      <span className="material-symbols-outlined counticon">
                                        how_to_reg
                                      </span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="col-lg-6 mb-3">
                              <div className="countbox">
                                <div className="row">
                                  <div className="col-lg-9">
                                    <div className="counttitle">
                                      {count?.total_comp_off_pending_status}
                                    </div>
                                    <h6 className="countsubtitle">
                                      Total Pending Comp Off
                                    </h6>
                                  </div>
                                  <div className="col-lg-3 my-auto">
                                    <div className="counticonbg">
                                      <span className="material-symbols-outlined counticon">
                                        pending_actions
                                      </span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="col-lg-6 mb-3">
                              <div className="countbox">
                                <div className="row">
                                  <div className="col-lg-9">
                                    <div className="counttitle">
                                      {count?.total_comp_off_approved_status}
                                    </div>
                                    <h6 className="countsubtitle">
                                      Total Approved Comp Off
                                    </h6>
                                  </div>
                                  <div className="col-lg-3 my-auto">
                                    <div className="counticonbg">
                                      <span className="material-symbols-outlined counticon">
                                        how_to_reg
                                      </span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="col-lg-4">
                          <div className="countbox">
                            <h6>Who’s on Leave</h6>
                            <div className="bottomborder"></div>
                            <div className="row my-3">
                              <div className="col-lg-6">
                                <h6 className="leaveboxtitle">
                                  On Leave :
                                  <span className="leaveboxtitlespan">
                                    &nbsp;
                                    {leavePerson?.length}
                                  </span>
                                </h6>
                              </div>
                              <div className="col-lg-6"></div>
                            </div>
                            {leavePerson.length > 0 ? (
                              leavePerson &&
                              leavePerson.map((leave, index) => {
                                return (
                                  <>
                                    <div className="row my-3" key={index}>
                                      <div className="col-lg-2">
                                        <div
                                          data-bs-toggle="dropdown"
                                          aria-expanded="false"
                                        >
                                          <div className="messageimageletternavbar">
                                            {GetInitials(leave?.name)}
                                          </div>
                                        </div>
                                      </div>
                                      <div className="col-lg-10">
                                        <h6 className="leaveboxnametitle">
                                          {leave?.name}
                                        </h6>
                                        <h6 className="leaveboxnamesubtitle">
                                          {moment(leave?.start_date).format(
                                            "MMM DD"
                                          )}{" "}
                                          to{" "}
                                          {moment(leave?.end_date).format(
                                            "MMM DD"
                                          )}
                                          - {leave?.leave_type}
                                        </h6>
                                      </div>
                                    </div>
                                  </>
                                );
                              })
                            ) : (
                              <div> No Leave Request Today</div>
                            )}
                          </div>
                        </div>
                      </div>
                    </>
                  ) : (
                    ""
                  )}
                </>
              ) : (
                ""
              )}
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default Dashboard;
